import { render, staticRenderFns } from "./HeroActionBar.vue?vue&type=template&id=0b00882f&"
import script from "./HeroActionBar.vue?vue&type=script&lang=js&"
export * from "./HeroActionBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports